<div class="cn-topbar">

  <div class="topbar-left">
    <span class="topbar-brand">NovarcPulse</span>
    <mat-icon class="topbar-chevron">chevron_right</mat-icon>
    <span class="topbar-page">{{ title }}</span>
  </div>

  <div class="topbar-right">
    <div class="header-attendance">
      <app-attendance-stopwatch></app-attendance-stopwatch>
    </div>
    <button class="topbar-icon-btn" matTooltip="Notifications" (click)="toggleNotifPanel()"
            [class.active]="showNotifPanel">
      <mat-icon>notifications_none</mat-icon>
      <span class="notif-badge" *ngIf="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>
    <button class="topbar-icon-btn" matTooltip="Settings" (click)="goToSettings()" *ngIf="canAccessSettings()">
      <mat-icon>settings</mat-icon>
    </button>
    <span class="topbar-divider"></span>
    <button class="topbar-avatar-btn" (click)="toggleProfilePanel()" [attr.aria-label]="'Account menu'">
      <img *ngIf="currentUser?.profilePicture" [src]="currentUser.profilePicture" class="topbar-avatar-img" alt="">
      <span *ngIf="!currentUser?.profilePicture">{{ getInitials() }}</span>
    </button>
  </div>
</div>

<div class="notif-backdrop" *ngIf="showNotifPanel" (click)="closeNotifPanel()"></div>
<div class="notif-panel" *ngIf="showNotifPanel">
  <div class="notif-head">
    <span class="notif-title">Notifications</span>
    <button class="notif-markall" *ngIf="unreadCount > 0" (click)="markAllNotifsRead()">Mark all read</button>
  </div>

  <div class="notif-list" *ngIf="notifications.length; else notifEmpty">
    <button class="notif-item" *ngFor="let n of notifications"
            [class.unread]="!n.read" (click)="onNotifClick(n)">
      <span class="notif-icon" [ngClass]="'cat-' + n.category">
        <mat-icon>{{ notifIcon(n.type) }}</mat-icon>
      </span>
      <span class="notif-body">
        <span class="notif-item-title">{{ n.title }}</span>
        <span class="notif-item-msg">{{ n.message }}</span>
        <span class="notif-item-time">{{ timeAgo(n.createdAt) }}</span>
      </span>
      <span class="notif-unread-dot" *ngIf="!n.read"></span>
    </button>
  </div>

  <ng-template #notifEmpty>
    <div class="notif-empty">
      <mat-icon>notifications_none</mat-icon>
      <span>You're all caught up</span>
    </div>
  </ng-template>
</div>

<div class="profile-panel-backdrop" *ngIf="showProfilePanel" (click)="closeProfilePanel()"></div>
<div class="profile-panel" [class.open]="showProfilePanel">

  <div class="pp-topbar">
    <span class="pp-topbar-title">User Profile</span>
    <button class="pp-close-btn" (click)="closeProfilePanel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="pp-identity">
    <div class="pp-avatar-lg">
      <img *ngIf="currentUser?.profilePicture" [src]="currentUser.profilePicture" class="pp-avatar-img" alt="">
      <span *ngIf="!currentUser?.profilePicture">{{ getInitials() }}</span>
    </div>
    <div class="pp-name">{{ currentUser?.firstName }} {{ currentUser?.lastName }}</div>
    <div class="pp-emp-id">EMPLOYEE ID: {{ currentUser?.employeeId || 'EMP000' }}</div>
    <div class="pp-email">{{ currentUser?.email }}</div>
    <div class="pp-reporting" *ngIf="reportingManagerName">
      <mat-icon class="pp-reporting-icon">supervisor_account</mat-icon>
      Reports to <strong>{{ reportingManagerName }}</strong>
    </div>
  </div>

  <div class="pp-profile-btn-wrap">
    <button class="pp-profile-btn" (click)="goToProfile(); closeProfilePanel()">
      <mat-icon>person_outline</mat-icon>
      View Full Profile
    </button>
    <button class="pp-profile-btn pp-profile-btn--secondary" (click)="openChangePassword()">
      <mat-icon>lock_outline</mat-icon>
      Change Password
    </button>
  </div>

  <div class="pp-section">
    <div class="pp-section-header">
      <span class="pp-section-title">Workspace Settings</span>
      <a class="pp-section-link" *ngIf="canAccessSettings()" (click)="goToSettings(); closeProfilePanel()">Configure</a>
    </div>
    <div class="pp-workspace-card" [class.pp-workspace-card--clickable]="canAccessSettings()" (click)="canAccessSettings() && goToSettings() && closeProfilePanel()">
      <div class="pp-ws-logo">
        <img src="novarc-logo.png" alt="logo" class="pp-ws-logo-img" onerror="this.style.display='none'">
      </div>
      <div class="pp-ws-info">
        <div class="pp-ws-name">{{ companyName || 'CyberNxt' }}</div>
        <div class="pp-ws-type">Enterprise Tenant</div>
      </div>
      <mat-icon class="pp-ws-arrow" *ngIf="canAccessSettings()">chevron_right</mat-icon>
    </div>
  </div>

  <div class="pp-footer">
    <button class="pp-logout-btn" (click)="logout()">
      <mat-icon>logout</mat-icon>
      Log out of session
    </button>
  </div>

</div>

<div class="cp-overlay" *ngIf="showChangePassword" (click)="closeChangePassword()"></div>
<div class="cp-modal" *ngIf="showChangePassword">
  <div class="cp-modal-header">
    <div class="cp-modal-title">
      <span class="cp-modal-icon"><mat-icon>lock_outline</mat-icon></span>
      Change Password
    </div>
    <button class="cp-close-btn" (click)="closeChangePassword()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="cp-modal-body">
    <div class="cp-field">
      <label class="cp-label">Current Password</label>
      <div class="cp-input-wrap">
        <input [type]="cpShowCurrent ? 'text' : 'password'" class="cp-input"
               [(ngModel)]="cpForm.currentPassword" placeholder="Enter current password" autocomplete="current-password">
        <button class="cp-toggle" type="button" (click)="cpShowCurrent = !cpShowCurrent">
          <mat-icon>{{ cpShowCurrent ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
    </div>

    <div class="cp-field">
      <label class="cp-label">New Password</label>
      <div class="cp-input-wrap">
        <input [type]="cpShowNew ? 'text' : 'password'" class="cp-input"
               [(ngModel)]="cpForm.newPassword" placeholder="At least 8 characters" autocomplete="new-password">
        <button class="cp-toggle" type="button" (click)="cpShowNew = !cpShowNew">
          <mat-icon>{{ cpShowNew ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
      <div class="cp-strength-bar-wrap" *ngIf="cpForm.newPassword">
        <div class="cp-strength-bar">
          <div class="cp-strength-fill" [style.width]="getPasswordStrength().width" [style.background]="getPasswordStrength().color"></div>
        </div>
        <span class="cp-strength-label" [style.color]="getPasswordStrength().color">{{ getPasswordStrength().label }}</span>
      </div>
    </div>

    <div class="cp-field">
      <label class="cp-label">Confirm New Password</label>
      <div class="cp-input-wrap">
        <input [type]="cpShowConfirm ? 'text' : 'password'" class="cp-input"
               [(ngModel)]="cpForm.confirmPassword" placeholder="Re-enter new password" autocomplete="new-password">
        <button class="cp-toggle" type="button" (click)="cpShowConfirm = !cpShowConfirm">
          <mat-icon>{{ cpShowConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
      <div class="cp-mismatch" *ngIf="cpForm.confirmPassword && cpForm.newPassword !== cpForm.confirmPassword">
        Passwords do not match
      </div>
    </div>
  </div>

  <div class="cp-modal-footer">
    <button class="cp-btn-cancel" (click)="closeChangePassword()" [disabled]="cpSubmitting">Cancel</button>
    <button class="cp-btn-submit" (click)="submitChangePassword()" [disabled]="cpSubmitting">
      <span *ngIf="!cpSubmitting">Update Password</span>
      <span *ngIf="cpSubmitting" class="cp-spinner"></span>
    </button>
  </div>
</div>

<div class="fullscreen-popup-overlay" *ngIf="showSettingsPopup">
  <div class="fullscreen-popup">
    <div class="fullscreen-popup-header">
      <h3>Settings</h3>
      <button mat-icon-button (click)="closeSettingsPopup()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="fullscreen-popup-body">
      <app-settings></app-settings>
    </div>
  </div>
</div>
